import { Form, Input, Col, Row, Divider, Tabs, Button, Space, Radio, message, Select, InputNumber, Tag } from "antd";
import { ListFournisService } from "../../Services/ListFournisService";
import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { SpecialitesService } from "../../Services/SpecialitesService";
import { PaysService } from "../../Services/PaysService";
import Region from "../Region";
import GeoLocationField from "./GeoLocationField";
import DepartementSelect from "../DepartementSelect";
import { ArrowLeftOutlined } from "@ant-design/icons";

const { Option } = Select;
const { TabPane } = Tabs;

const EditFournisseur = ({ selectedRowForEdit }) => {
  const { numFourn } = useParams();
  const [fournisseurDetails, setFournisseurDetails] = useState(null);
  const [specialitesData, setSpecialitesData] = useState([]);
  const [pays, setPays] = useState([]);
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const userId = localStorage.getItem('login');

  const listFournisService = new ListFournisService();
  const specialistesService = new SpecialitesService();
  const paysService = new PaysService()
  useEffect(() => {
    if (numFourn) {
      listFournisService.getOneListFournis(numFourn)
        .then((data) => {
          setFournisseurDetails(data);
          form.setFieldsValue(data);
        })
        .catch((error) => {
          console.error('Erreur lors de la récupération des détails du fournisseur :', error);
        });
    }
  }, [numFourn, form]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const specialites = await specialistesService.getAllSpecialites();
        setSpecialitesData(specialites);
        const paysData = await paysService.getAllPays();
        setPays(paysData);
      } catch (error) {
        console.error("Erreur lors de la récupération des données :", error);
      }
    };

    fetchData();
  }, []);


  const handleInputChange = (fieldName, value) => {
    setFournisseurDetails((prevDetails) => ({
      ...prevDetails,
      [fieldName]: value,
    }));
    form.setFieldsValue({ [fieldName]: value });
  };

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      const payload = {
        ...fournisseurDetails,
        ...values,
        user_id: userId,
      };
      await listFournisService.updateListFournis(payload);
      message.success("Fournisseur mis à jour avec succès");
      await listFournisService.getAllListFournis();
      navigate("/fournisseurs")
    } catch (error) {
      console.error('Erreur lors de la mise à jour :', error);
      message.error("Erreur lors de la mise à jour du fournisseur");
    }
  };

  const getButtonStyles = (value, selectedValue) => {
    const isSelected = value === selectedValue;
    const backgroundColor = isSelected ? (value === "A" ? "#67f02e" : "#e80202") : "#fff";
    const borderColor = isSelected ? (value === "A" ? "#67f02e" : "#e80202") : "#d9d9d9";
    const textColor = isSelected ? "#fff" : (value === "A" ? "#e80202" : "#67f02e");

    return {
      backgroundColor,
      borderColor,
      color: textColor,
    };
  };

  const getRadioButtonStyle = (value) => {
    const isSelected = selectedAgree === value;
    let backgroundColor, color;

    switch (value) {
      case 'C':
        backgroundColor = isSelected ? '#e0ce07' : 'transparent';
        color = 'black';
        break;
      case 'A':
        backgroundColor = isSelected ? '#67f02e' : 'transparent';
        color = 'black';
        break;
      case 'R':
        backgroundColor = isSelected ? '#fc0b03' : 'transparent';
        color = 'black';
        break;
      default:
        backgroundColor = 'transparent';
        color = 'black';
        break;
    }

    return { backgroundColor, color };
  };

  const getRadioGroupStyle = () => {
    switch (selectedAgree) {
      case 'C':
        return { borderColor: '#e0ce07' };
      case 'A':
        return { borderColor: '#67f02e' };
      case 'R':
        return { borderColor: '#fc0b03' };
      default:
        return {};
    }
  };


  const getGroupBorderColor = (selectedValue) => {
    if (selectedValue === "A") {
      return "#67f02e";
    } else if (selectedValue === "S") {
      return "#e80202";
    }
    return "#d9d9d9";
  };

  const getStatusTagProps = (statut) => {
    switch (statut) {
      case "A":
        return { color: "#67f02e", label: "Actif" };
      case "S":
        return { color: "#e80202", label: "Suspendu" };
      default:
        return { color: "#d9d9d9", label: "Statut inconnu" };
    }
  };

  const getAgreeTagProps = (agree) => {
    switch (agree) {
      case "A":
        return { color: "#67f02e", label: "Agréé" };
      case "N":
        return { color: "#f1c40f", label: "Non agréé" };
      case "C":
        return { color: "#1890ff", label: "En cours" };
      case "R":
        return { color: "#e80202", label: "Rejeté" };
      default:
        return { color: "#d9d9d9", label: "Agrément inconnu" };
    }
  };

  const selectedStatus = form.getFieldValue('statut') || (fournisseurDetails && fournisseurDetails.statut);
  const selectedAgreement = form.getFieldValue('agree') || (fournisseurDetails && fournisseurDetails.agree);
  const selectedAgree = form.getFieldValue('agree') || (fournisseurDetails && fournisseurDetails.agree);
  const statusTag = getStatusTagProps(selectedStatus);
  const agreeTag = getAgreeTagProps(selectedAgreement);

  return (
    <div style={{ borderRadius: '14px', boxShadow: '0 8px 24px rgba(0, 0, 0, 0.08)', padding: '20px', width: '100%', margin: '0 auto', backgroundColor: '#f6f8fb' }}>

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: 'linear-gradient(135deg, #0f2d52, #174a7a)', borderRadius: '12px', padding: '16px 20px', color: '#fff', marginBottom: 18 }}>
        <div>
          <div style={{ fontSize: '13px', opacity: 0.85 }}>Fournisseur</div>
          <div style={{ fontSize: '20px', fontWeight: 700 }}>
            {fournisseurDetails ? `N° ${fournisseurDetails.numFourn} · ${fournisseurDetails.raisoc || ''}` : 'Chargement...'}
          </div>
          <div style={{ fontSize: '13px', opacity: 0.9 }}>{fournisseurDetails?.adresse || ''}</div>
        </div>
        <Space size={10} align="center">
          {fournisseurDetails && (
            <>
              <Tag color={statusTag.color} style={{ padding: '4px 10px', borderRadius: 12, fontWeight: 600 }}>{statusTag.label}</Tag>
              <Tag color={agreeTag.color} style={{ padding: '4px 10px', borderRadius: 12, fontWeight: 600 }}>{agreeTag.label}</Tag>
            </>
          )}
          <Link to="/fournisseurs">
            <Button
              type="primary"
              shape="round"
              size="middle"
              icon={<ArrowLeftOutlined />}
            >
              Retour
            </Button>
          </Link>
        </Space>
      </div>

      <Form
        form={form}
        layout="vertical"
        initialValues={selectedRowForEdit}
        style={{ width: '100%', margin: "0 auto", background: '#fff', borderRadius: 12, padding: 18, border: '1px solid #e9edf3' }}
      >
        <Divider orientation="left"></Divider>
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item label="Spécialité" name="codespe">
              {/*  <Input disabled value={fournisseurDetails && fournisseurDetails.intitule} /> */}
              <Select
                style={{ width: "100%" }}
                defaultValue={"--Selectionner--"}
                disabled
              >
                {specialitesData.map((specialite) => (
                  <Option key={specialite.codespe} value={specialite.codespe}>
                    {` ${specialite.intitule}`}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="N°" name="numFourn">
              <Input disabled value={fournisseurDetails && fournisseurDetails.numFourn} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label="Raison Sociale"
              name="raisoc"
              rules={[
                {
                  required: true,
                  message: "Veuillez saisir la Raison Sociale",
                },
              ]}
            >
              <Input value={fournisseurDetails && fournisseurDetails.raisoc} onChange={(e) => handleInputChange('raisoc', e.target.value)} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item label="Email" name="email">
              <Input value={fournisseurDetails && fournisseurDetails.email} onChange={(e) => handleInputChange('email', e.target.value)} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Téléphone Fixe" name="telFix">
              <Input value={fournisseurDetails && fournisseurDetails.telFix} onChange={(e) => handleInputChange('telFix', e.target.value)} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Téléphone Mobile" name="portable">
              <Input value={fournisseurDetails && fournisseurDetails.portable} onChange={(e) => handleInputChange('portable', e.target.value)} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Adresse" name="adresse">
              <Input value={fournisseurDetails && fournisseurDetails.adresse} onChange={(e) => handleInputChange('adresse', e.target.value)} />
            </Form.Item>
          </Col>
          <Col span={6}>
            {fournisseurDetails && fournisseurDetails.agree === 'A' ? (
              <Space>
                <Form.Item label="Etat" name="statut">
                  <Radio.Group
                    value={selectedStatus}
                    onChange={(e) => handleInputChange('statut', e.target.value)}
                    style={{ borderColor: getGroupBorderColor(selectedStatus), borderWidth: 1, borderStyle: 'solid', borderRadius: 4 }}
                  >
                    <Radio.Button value="A" style={getButtonStyles("A", selectedStatus)}>Actif</Radio.Button>
                    <Radio.Button value="S" style={getButtonStyles("S", selectedStatus)}>Suspendu</Radio.Button>
                  </Radio.Group>
                </Form.Item>
                <Form.Item label="Agrée" name="agree">
                  <Radio.Group
                    value={selectedAgreement}
                    onChange={(e) => handleInputChange('agree', e.target.value)}
                    style={{ borderColor: getGroupBorderColor(selectedAgreement), borderWidth: 1, borderStyle: 'solid', borderRadius: 4 }}
                  >
                    <Radio.Button value="A" style={getButtonStyles("A", selectedAgreement)}>OUI</Radio.Button>
                    <Radio.Button value="N" style={getButtonStyles("N", selectedAgreement)}>NON</Radio.Button>
                  </Radio.Group>
                </Form.Item>
              </Space>
            ) : (
              <Form.Item name="agree" label="Agrément" rules={[{ required: true, message: "Veuillez sélectionner l'agrément" }]}>
                <Radio.Group
                  value={selectedAgree}
                  onChange={(e) => handleInputChange('agree', e.target.value)}
                  style={{ borderColor: getRadioGroupStyle().borderColor, borderWidth: 1, borderStyle: 'solid', borderRadius: 4 }}
                >
                  <Radio.Button style={getRadioButtonStyle('C')} value="C">En cours</Radio.Button>
                  <Radio.Button style={getRadioButtonStyle('A')} value="A">Agréé</Radio.Button>
                  <Radio.Button style={getRadioButtonStyle('R')} value="R">Rejeté</Radio.Button>
                </Radio.Group>
              </Form.Item>
            )}
          </Col>
          <Col span={6}>
            <Form.Item label="Delai de Règlement (jr)" initialValue={60} name="delai_credit">
              <InputNumber
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
        </Row>
        <Divider orientation="left">Contact</Divider>
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item label="Nom" name="contact_nom">
              <Input value={fournisseurDetails && fournisseurDetails.contact_nom} onChange={(e) => handleInputChange('contact_nom', e.target.value)} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Prénom" name="contact_prenom">
              <Input value={fournisseurDetails && fournisseurDetails.contact_prenom} onChange={(e) => handleInputChange('contact_prenom', e.target.value)} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Fonction" name="contact_fonction">
              <Input value={fournisseurDetails && fournisseurDetails.contact_fonction} onChange={(e) => handleInputChange('contact_fonction', e.target.value)} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item label="Téléphone Mobile" name="contact_portable">
              <Input value={fournisseurDetails && fournisseurDetails.contact_portable} onChange={(e) => handleInputChange('contact_portable', e.target.value)} />
            </Form.Item>
          </Col>

        </Row>
        <Divider orientation="left"></Divider>
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item name="typeStructure" label="Type de structure" >
              <Select>
                <Option value="public">Public</Option>
                <Option value="prive">Privé</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="but" label="But" >
              <Select>
                <Option value="lucratif">Lucratif</Option>
                <Option value="nonLucratif">Non Lucratif</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="niveau" label="Niveau" >
              <Select>
                <Option value="n1">N1</Option>
                <Option value="n2">N2</Option>
                <Option value="n3">N3</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="code_ipm" label="Code IPM" >
              <Input />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="N.I.N.U" name="ninu">
              <Input style={{ width: "100%" }} />
            </Form.Item>
          </Col>
        </Row>
        <Divider orientation="left">Information personnelles du fournisseur</Divider>
        <Tabs defaultActiveKey="1" type="card" tabBarGutter={24}>
          <TabPane tab="Identification bancaire" key="1">
            <Row gutter={16}>
              <Col span={8}>
                <Form.Item label="Nom Banque" name="banque">
                  <Input value={fournisseurDetails && fournisseurDetails.banque} onChange={(e) => handleInputChange('banque', e.target.value)} />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="Code Banque" name="codeBque">
                  <Input value={fournisseurDetails && fournisseurDetails.codeBque} onChange={(e) => handleInputChange('codeBque', e.target.value)} />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="Code Guichet" name="codeAgence">
                  <Input value={fournisseurDetails && fournisseurDetails.codeAgence} onChange={(e) => handleInputChange('codeAgence', e.target.value)} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Compte Bancaire" name="compte">
                  <Input value={fournisseurDetails && fournisseurDetails.compte} onChange={(e) => handleInputChange('compte', e.target.value)} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Clé RIB" name="cleRib">
                  <Input value={fournisseurDetails && fournisseurDetails.cleRib} onChange={(e) => handleInputChange('cleRib', e.target.value)} />
                </Form.Item>
              </Col>

            </Row>
          </TabPane>
          <TabPane tab="Localisation" key="2">
            <Row gutter={16}>
              <Col span={8}>

                {/*  <Input value={fournisseurDetails && fournisseurDetails.region} onChange={(e) => handleInputChange('region', e.target.value)} /> */}
                <Form.Item label="Région" name="region" >
                  <Region />
                </Form.Item>

              </Col>
              <Col span={8}>
                <Form.Item label="Département" name="deptmt" >
                  <DepartementSelect />
                </Form.Item>

              </Col>
              <Col span={8}>
                <Form.Item label="Pays" name="pays">
                  {/*  <Input value={fournisseurDetails && fournisseurDetails.pays} onChange={(e) => handleInputChange('pays', e.target.value)} /> */}
                  <Select
                    style={{ width: "100%" }}
                    defaultValue={"--Selectionner--"}
                  // disabled
                  >
                    {pays.map((paysdata) => (
                      <Option key={paysdata.alpha3} value={paysdata.alpha3}>
                        {` ${paysdata.alpha3} - ${paysdata.nom_fr_fr}`}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="Site web" name="siteweb">
                  <Input value={fournisseurDetails && fournisseurDetails.siteweb} onChange={(e) => handleInputChange('siteweb', e.target.value)} />
                </Form.Item>
              </Col>
            </Row>
            <Form.Item
              name="coordgeo"
              label="Coordonnées géographiques"

            >
              <GeoLocationField />
            </Form.Item>
          </TabPane>
          <TabPane tab="Documents administratifs" key="3">
            <Row gutter={16}>
              <Col span={8}>
                <Form.Item label="N° Inscription au Tableau de l'Ordre" name="num_ordre">
                  <Input value={fournisseurDetails && fournisseurDetails.num_ordre} onChange={(e) => handleInputChange('num_ordre', e.target.value)} />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="N° Carte Professionnelle" name="num_carte_pro">
                  <Input value={fournisseurDetails && fournisseurDetails.num_carte_pro} onChange={(e) => handleInputChange('num_carte_pro', e.target.value)} />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="N° Arrêté Autorisation" name="num_arret_aut">
                  <Input value={fournisseurDetails && fournisseurDetails.num_arret_aut} onChange={(e) => handleInputChange('num_arret_aut', e.target.value)} />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="Date Fin Validité Carte Professionnelle" name="date_fin_carte_pro">
                  <Input value={fournisseurDetails && fournisseurDetails.date_fin_carte_pro} onChange={(e) => handleInputChange('date_fin_carte_pro', e.target.value)} />
                </Form.Item>
              </Col>
            </Row>
          </TabPane>
          <TabPane tab="Convention" key="4">
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item label="Date Début Convention" name="dateDebConv">
                  <Input value={fournisseurDetails && fournisseurDetails.dateDebConv} onChange={(e) => handleInputChange('dateDebConv', e.target.value)} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Date Fin Convention" name="dateFinConv">
                  <Input value={fournisseurDetails && fournisseurDetails.dateFinConv} onChange={(e) => handleInputChange('dateFinConv', e.target.value)} />
                </Form.Item>
              </Col>
            </Row>
          </TabPane>
        </Tabs>
        <Form.Item style={{ textAlign: "right" }}>
          <Space>
            <Link to="/fournisseurs">
              <Button type="default" className="buttonClose">Annuler</Button>
            </Link>
            <Button onClick={handleSubmit} className="buttonEdit">Modifier</Button>
          </Space>
        </Form.Item>
      </Form>
    </div>
  );
};

export default EditFournisseur;
